import { render, staticRenderFns } from "./BeneficiariosListado.vue?vue&type=template&id=25850148&scoped=true&"
import script from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
export * from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariosListado.vue?vue&type=style&index=0&id=25850148&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25850148",
  null
  
)

export default component.exports